var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessSavings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 65,
    viewBox: "0 0 74 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow 1",
    d: "M36.6246 47.0791C37.2206 47.6545 38.1702 47.6379 38.7456 47.0419L48.1226 37.33C48.6981 36.734 48.6814 35.7844 48.0854 35.209C47.4894 34.6336 46.5398 34.6502 45.9644 35.2462L37.6293 43.879L28.9965 35.5439C28.4005 34.9685 27.4509 34.9851 26.8755 35.5811C26.3001 36.1771 26.3167 37.1267 26.9127 37.7021L36.6246 47.0791ZM35.6667 17.5263L36.1667 46.0263L39.1663 45.9737L38.6663 17.4737L35.6667 17.5263Z",
    fill: "#9AC8B9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 87",
    d: "M72.1665 32.5C72.1665 49.4619 56.6649 63.5 37.1665 63.5C17.6681 63.5 2.1665 49.4619 2.1665 32.5C2.1665 15.5381 17.6681 1.5 37.1665 1.5C56.6649 1.5 72.1665 15.5381 72.1665 32.5Z",
    stroke: "#9AC8B9",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessSavings);
export default __webpack_public_path__ + "static/media/BusinessSavings.fa47f873b7e106dfa955085c0908e816.svg";
export { ForwardRef as ReactComponent };